<template>
  <div class="content">
    <div>
      <img class="icon icon--link icon--bottom" src="@images/arrow-left.svg" v-svg-inline>
      <router-link :to="{ name: 'secretary.form', params: { id: route.params.formId, tab: 'applications' } }">Вернуться назад</router-link>
    </div>

    <div v-if="store.loading" class="content content--center">
      <p>Загрузка...</p>
    </div>

    <application-layout v-else readonly @refetch="onRefetch"/>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { ApplicationLayout, useApplicationStore } from '@widgets/application-profile'

const route = useRoute()
const store = useApplicationStore()

onBeforeMount(() => store.fetchForSecretary(route.params.formId, route.params.applicationId))
const onRefetch = () => store.fetchForSecretary(route.params.formId, route.params.applicationId, true)
</script>
